import styled from 'styled-components';

export const TextContainer = styled.div`
	width: 100%;
	padding: 4px 0px;

	display: flex;
	flex-direction: column;
	align-items: center;
	align-self: stretch;
	gap: 4px;
`;

export const SingleInputFormPopupErrorMessageWrapper = styled.div`
	padding: 0px 4px;

	position: absolute;
	left: 20px;
	bottom: 8px;
`;

export const SingleInputFormPopupTextHeader = styled.div`
	width: 100%;

	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`;
